export default __webpack_public_path__ + "static/media/close.17a94979.svg";